import { FilterModel } from 'ag-grid-enterprise';
import { BFFBaseFilter } from '../api';
import { FILTER_TYPES, FilterTypes } from '../constants';

export const getFiltersFromFilterModel = (
  filterModel: FilterModel,
  defaultFilter?: BFFBaseFilter,
  useNumberAsContainsFilter = false
): BFFBaseFilter[] => {
  const filters = defaultFilter ? [defaultFilter] : [];
  if (filterModel || Object.keys(filterModel).length)
    return filters.concat(
      Object.entries(filterModel).map(([key, colFilter]) => ({
        column: key,
        values: getValues(colFilter),
        searchType: getSearchType(colFilter, useNumberAsContainsFilter)
      }))
    );
  return filters;
};

const getValues = (filterModel: FilterModel) => {
  const isSetFilter = filterModel.filterType == FILTER_TYPES.Set;
  return isSetFilter ? filterModel.values : [filterModel.filter];
};

const getSearchType = (
  filterModel: FilterModel,
  useNumberAsContainsFilter = false
) => {
  const isTextFilter = filterModel.filterType == FILTER_TYPES.Text;
  const isNumberFilter = filterModel.filterType == FILTER_TYPES.Number;
  const useNumberAsContains = isNumberFilter && useNumberAsContainsFilter;
  return isTextFilter || useNumberAsContains
    ? FilterTypes.CONTAINS
    : FilterTypes.EQUALS;
};

// TODO : To be enabled as and when required.
// export const nullToAllValueFormatter = (value: string) =>
//   value ? value : 'All';
